import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Card } from "@mui/material";
import confirm from "../Images/confirm.png";
import cancel from '../Images/ic-failed.png'
import { useGetAPIWithoutTokenQuery } from "../Api/api";
import { READ_ONE_EVENT } from "../Api/apiConstant";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
const ConfirmOrder = () => {
  const eventId = sessionStorage.getItem("event_id");
  const eventName = sessionStorage.getItem("eventName");
  const location = useLocation();
  const navigate = useNavigate();

  const { order_id, totalDiscount, status } = location.state;

  const { data, isLoading, isError, isSuccess } = useGetAPIWithoutTokenQuery(
    `${READ_ONE_EVENT}${eventId}`
  );

  const handleRetry = () => {
    navigate(`/events/${eventName}/cart`)
  }

  return (
    <>
      <div className="bg-light overflow-hidden">
        <Navbar className="sticky-navbar" />
        <div
          className="container-fluid d-flex justify-content-center align-items-center"
          style={{ marginTop: "16vh" }}
        >
          {
            status == "COMPLETED" || status == "AUTHORIZED" ?
              <Card
                className="text-center  my-3 w-100"
                style={{
                  maxWidth: "500px",
                  borderRadius: "16px",
                  boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
                  border: "2px dashed #D2D2D2",
                  padding: "2% 5%",
                }}
              >
                <img
                  src={confirm}
                  alt="Order Confirmation"
                  className="img-fluid"
                  style={{ maxWidth: "100px" }}
                />
                <p className="mt-4" style={{ fontSize: "24px", fontWeight: "600" }}>
                  Thank You for Pre-Order
                </p>
                <p
                  style={{ fontSize: "20px", fontWeight: "400", color: "#484848" }}
                >
                  Order Id : {order_id}
                </p>
                {totalDiscount > 0 && (
                  <p
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      backgroundColor: "#E3FFEE",
                      color: "#379246",
                      borderRadius: "6px",
                    }}
                  >
                    Great! You just saved ${totalDiscount} !
                  </p>
                )}

                <Card
                  className="p-4"
                  style={{
                    borderRadius: "20px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: "#FAFAFA",
                  }}
                >
                  <p
                    style={{
                      fontSize: "19px",
                      fontWeight: "600",
                      color: "#484848",
                      textAlign: "left",
                    }}
                  >
                    {new Date().toLocaleDateString("en-US", {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                  <Card
                    className="p-4"
                    style={{
                      borderRadius: "11px",
                      backgroundColor: "#F6F6F6",
                      textAlign: "left",
                    }}
                  >
                    <div 
                      className="inline-block px-3 py-1 mb-3"
                      style={{
                        borderRadius: "9px",
                        backgroundColor: "#CEF3DD",
                        fontSize: "14px",
                        fontWeight: "600",
                        width: "35%"
                      }}
                    >
                      Event
                    </div>
                    <p style={{ fontSize: "14px", fontWeight: "700",  marginBottom: "10px" }}>
                      {data?.event_name}
                    </p>
                    <div className="d-flex align-items-center">
                      <img
                        height={20}
                        width={20}
                        src={data?.event_img_path}
                        style={{ marginRight: "8px" }}
                      />
                      <p
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#565656",
                          margin: 10,
                        }}
                      >
                        {data?.event_address}
                      </p>
                    </div>
                  </Card>
                </Card>
              </Card>
              : status == "Pending" ?
                <Card
                  className="text-center  my-3 w-100"
                  style={{
                    maxWidth: "500px",
                    borderRadius: "16px",
                    boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
                    border: "2px dashed #D2D2D2",
                    padding: "2% 5%",
                  }}
                >
                  <img
                    src={cancel}
                    alt="Order Confirmation"
                    className="img-fluid"
                    style={{ maxWidth: "100px" }}
                  />
                  <p className="mt-4" style={{ fontSize: "20px", fontWeight: "600" }}>
                    Payment deducted, but the order was not placed successfully. Please allow us some time to review or contact support for help.                  </p>
                </Card>
                : status == "CANCELED" || status == "FAILED" || status == "DECLINED" ?
                  <Card
                    className="text-center  my-3 w-100"
                    style={{
                      maxWidth: "500px",
                      borderRadius: "16px",
                      boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
                      border: "2px dashed #D2D2D2",
                      padding: "2% 5%",
                    }}
                  >
                    <img
                      src={cancel}
                      alt="Order Confirmation"
                      className="img-fluid"
                      style={{ maxWidth: "100px" }}
                    />
                    <p className="mt-4" style={{ fontSize: "20px", fontWeight: "600" }}>
                      Payment {status}. Please reorder
                    </p>
                  </Card>
                  : !status ?
                    <Card
                      className="text-center  my-3 w-100"
                      style={{
                        maxWidth: "500px",
                        borderRadius: "16px",
                        boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
                        border: "2px dashed #D2D2D2",
                        padding: "2% 5%",
                      }}
                    >
                      <img
                        src={cancel}
                        alt="Order Confirmation"
                        className="img-fluid"
                        style={{ maxWidth: "100px" }}
                      />
                      <p className="mt-4" style={{ fontSize: "20px", fontWeight: "600" }}>
                        We apologies, something went wrong with your order, Please try again.
                      </p>
                      <CustomButton
                        text="Retry"
                        size="sm"
                        className="mt-2 py-1 px-3"
                        block={true}
                        onClick={handleRetry}
                      />
                    </Card>
                    : ""
          }
        </div>
        <p
          className="my-5"
          style={{
            fontSize: "18px",
            fontWeight: "500",
            color: "#404040",
            textDecoration: "underline",
            textAlign: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onClick={() => navigate(`/events/${eventName}`)}
        >
          Back to Home
        </p>

        <Footer />
      </div>
    </>
  );
};

export default ConfirmOrder;
